import moment from 'moment';
import { useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Typography } from '@tempmee/react';
import { colors } from '@tempmee/tailwind';
import { Box } from '~/commonComponents';
import { getAllJobs } from '../../../../actions';
import { createDaysOfWeekArray } from '../../utils';
import { DayCard } from './components/DayCard/DayCard';

const getFilteredJobs = (jobs, status) => {
  let statusToFilter = status;

  if (status === 'all') {
    return Object.fromEntries(
      Object.entries(jobs).map(([date, objects]) => [
        date,
        objects.filter((obj) => obj.status !== 'today' && obj.status !== 'cancelled-or-expired'),
      ]),
    );
  }

  if (status === 'pending-counter') {
    statusToFilter = 'pending';
  }

  return Object.fromEntries(
    Object.entries(jobs).map(([date, objects]) => [
      date,
      objects.filter((obj) => obj.status === statusToFilter),
    ]),
  );
};

const daysOfWeekArray = ['SUN', 'MON', 'TUE', 'WED', 'THU', 'FRI', 'SAT'];

export const Calendar = ({ status }) => {
  const dispatch = useDispatch();
  const schedule = useSelector((state) => state.job.schedule);
  const selectedMonth = moment(schedule.dateRange.start).month();
  const jobsPerDay = useSelector((state) => state.job.jobsPerDay);

  const jobsFiltered = useMemo(() => getFilteredJobs(jobsPerDay, status), [jobsPerDay, status]);
  const dateArray = useMemo(
    () => createDaysOfWeekArray(schedule.dateRange.start),
    [schedule.dateRange],
  );

  useEffect(() => {
    const debounceTimeout = setTimeout(() => {
      dispatch(getAllJobs({ ...schedule.dateRange }));
    }, 300);

    return () => clearTimeout(debounceTimeout);
  }, [schedule.dateRange, dispatch]);

  return (
    <div>
      <div
        style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(7, 1fr)',
          gap: 8,
          marginBottom: 12,
          height: 40,
        }}
      >
        {daysOfWeekArray.map((day, index) => (
          <Box
            key={day}
            backgroundColor={colors.primary[100]}
            justifyContent="center"
            paddingLeft={16}
            borderTopLeftRadius={index === 0 ? 12 : 0}
            borderTopRightRadius={index === 6 ? 12 : 0}
          >
            <Typography as="span" color={colors.primary[500]} style={{ fontWeight: 600 }}>
              {day}
            </Typography>
          </Box>
        ))}
      </div>
      <div
        style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(7, 1fr)',
          gap: 8,
          justifyItems: 'center',
        }}
      >
        {dateArray.map((dateString) => (
          <DayCard
            key={dateString}
            jobs={jobsFiltered[dateString]}
            status={status}
            dateString={dateString}
            disabled={selectedMonth !== moment(dateString).month()}
          />
        ))}
      </div>
    </div>
  );
};
